import { useEffect, useRef } from "react";
import api from "./axiosAuth";

const REPORT_LABEL_KEYS = {
  "/POSDashboard": "POSDashboard",
  "/POSDashboardWithCombo": "POSDashboardWithCombo",
  "/SupDashboard": "SupervisorsDashboard",
  "/branches": "Branches",
  "/cities": "Cities",
  "/countries": "Countries",
  "/sales-areas": "SalesAreas",
  "/employees": "Employees",
  "/warehouses": "Warehouses",
  "/item-cost-categories": "ItemCostCategories",
  "/hourly-item-snapshots": "HourlyItemSnapshots",
  "/shift-closings-openings": "ShiftGapsReport",
  "/item-cost-by-period-list": "ItemCostByPeriod",
  "/POSLiveData": "POSLiveData",
  "/branch-current-inventory": "BranchCurrentInventory",
  "/hourly-inventory-balance": "HourlyInventoryBalance",
  "/hourly-inventory-balance-history": "HourlyInventoryBalanceHistory",
  "/pastry-outage-hours-summary": "PastryOutageHoursSummary",
  "/inventory": "InventoryCount",
  "/dispatch-by-category": "DispatchByCategory",
  "/dispatch-by-item": "DispatchByItem",
  "/dispatch-by-details": "DispatchByDetails",
  "/WHDashboard": "WHDashboard",
  "/WholesaleCollectionsDashboard": "WholesaleCollectionsDashboard",
  "/WholesaleDashboard": "Wholesale Sales",
  "/vendor": "Supplier Review Balance",
  "/UsedCardsByLoyaltyProgram": "UsedCardsByLoyaltyProgram",
  "/OrdersSourcePerHour": "OrdersSourcePerHour",
  "/OrdersBranchSourcePerHour": "OrdersBranchSourcePerHour",
  "/OrdersBranchSourcePerPeriod": "OrdersBranchSourcePerPeriod",
  "/SalesDifference": "SalesDifference",
  "/legacy-sales-archive": "LegacySalesArchive",
};

export function reportPathLabel(path, t) {
  const key = REPORT_LABEL_KEYS[path];
  if (!key) return path || "";
  return t(key);
}

export function logAuditEvent(code, target) {
  const body = { code };
  if (target !== undefined && target !== null && target !== "") {
    body.target = target;
  }
  api.post("/api/audit-log/event/", body).catch(() => {});
}

export function useAuditEventOnce(code, target) {
  const sentKey = useRef(null);
  useEffect(() => {
    const key = `${code}\0${target ?? ""}`;
    if (sentKey.current === key) return;
    sentKey.current = key;
    logAuditEvent(code, target);
  }, [code, target]);
}
